import React, { useState, useEffect } from 'react';
import { GetServerSidePropsContext } from 'next';
import Head from 'next/head';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { localeFiles } from '../../../data/constants';
import Button from '../../../components/atoms/Button';
import CreateItem from '../../../components/organisms/CreateItem';
import PageDefault from '../../../components/templates/PageDefault';
import styles from '../../../styles/pages/Create.module.scss';
import router from 'next/router';

interface PageProps {
  type?: string;
  locale: string;
  referer?: string;
}

const Page = (props: PageProps) => {
  const { t } = useTranslation(['common', 'pages']);
  const { type } = props;
  const comesFromMyBussinesses = props.referer?.includes('my-businesses');
  const goBack = () => {
    comesFromMyBussinesses ? router.back() : router.push('/');
  };

  return (
    <>
      <Head>
        <title>
          {t(`pages:promote-your-business:title`)} | {t('app-name')}
        </title>
        <meta
          name="description"
          content={t(`pages:promote-your-business:description`)}
        />
      </Head>

      <PageDefault className={styles.page_create} authOnly>
        <Row>
          <Col>
          <Button
              onClick={goBack}
              text
              iconLeft
              label={
                comesFromMyBussinesses
                  ? t('common:back-to-my-businesses')
                  : t('common:back-to-overview')
              }
            />
            <br />
            <br />
          </Col>
        </Row>
        <CreateItem prefill={!!type ? { type } : undefined} />
      </PageDefault>
    </>
  );
};

export default Page;

export async function getServerSideProps(context: GetServerSidePropsContext) {
  const { params: { type } = {}, locale } = context;
  return {
    props: {
      type,
      ...(await serverSideTranslations(locale!, localeFiles)),
      referer: context.req.headers.referer || '/',
    },
  };
}
